var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"header"},[_c('Header')],1),_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('div',{staticClass:"footer"},[_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }